<template>
  <v-container>
    <v-row v-if="error">
      <v-col
        cols="12"
        sm="6"
        offset-sm="3"
      >
        <app-alert
          :text="error.message"
          @dismissed="onDismissed"
        ></app-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        offset-sm="3"
      >
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignin">
                <validation-observer
                  ref="observer"
                  v-slot="{ invalid }"
                >
                  <v-row>
                    <v-col cols="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Email"
                        rules="required|email"
                      >
                        <v-text-field
                          id="email"
                          v-model="email"
                          name="email"
                          label="Email"
                          type="email"
                          required
                          outlined
                          prepend-inner-icon="mdi-email-outline"
                          :error-messages="errors"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        class="primary whtie--text mr-0 login-btn-new"
                        block
                        large
                        :disabled="invalid"
                        @click="resetPass"
                      >
                        <span class="login-btn">Send Reset Email</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </validation-observer>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

  <script>
  export default {
    data () {
      return {
        email: '',
        password: '',
        show: false,
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      }
    },
    methods: {
      resetPass () {
        this.$store.dispatch('sendRecoveryEmail', { email: this.email })
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      }
    }
  }
  </script>

  <style scoped>
    .custom-loader {
      animation: loader 1s infinite;
      display: flex;
    }
    @-moz-keyframes loader {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }
    @-webkit-keyframes loader {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }
    @-o-keyframes loader {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }
    @keyframes loader {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }
  </style>
